// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.n5E1LnZtLcTxxG1E {
	font: var(--lok-typography-body-small-strong);
	font-family: var(--lok-font-family-inter);
}
`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/BaseProfileModal/components/BaseProfileBasicsStep/BaseProfileBasicsStep.module.css"],"names":[],"mappings":"AAAA;CACC,6CAA6C;CAC7C,yCAAyC;AAC1C","sourcesContent":[".heading {\n\tfont: var(--lok-typography-body-small-strong);\n\tfont-family: var(--lok-font-family-inter);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heading": `n5E1LnZtLcTxxG1E`
};
export default ___CSS_LOADER_EXPORT___;
